import { ContentSection, FaqItem } from '@/types'

interface LandingContent {
  intro: string
  sections: ContentSection[]
  faqs: FaqItem[]
}

/**
 * Dönüşüm odaklı hizmet sayfalarının uzun içeriği.
 * Sayfa bileşenleri yalnızca düzeni kurar; metin buradadır.
 *
 * Fiyat rakamı yazılmaz — muayene, kilo ve anestezi riskine göre
 * değiştiğinden yanıltıcı olur. Fiyatı etkileyen faktörler açıklanır.
 */

export const acilContent: LandingContent = {
  intro:
    'Acil bir durumda kaybedilen her dakika önemlidir. Aşağıda hangi belirtilerin gerçekten acil ' +
    'olduğunu, kliniğe ulaşana kadar evde ne yapmanız (ve ne yapmamanız) gerektiğini bulacaksınız. ' +
    'Şüphedeyseniz beklemeyin — arayın, telefonda birlikte değerlendirelim.',
  sections: [
    {
      heading: 'Hangi durumlar gerçekten acildir?',
      paragraphs: [
        'Aşağıdaki belirtiler saatler içinde hayati tehlike oluşturabilir. Bu tabloyu telefonunuza ' +
        'kaydetmeniz, panik anında doğru kararı vermenizi kolaylaştırır.'
      ],
      table: {
        caption: 'Vakit kaybetmeden kliniğe gelmeniz gereken durumlar',
        columns: ['Belirti', 'Neden acil'],
        rows: [
          ['Nefes almakta zorlanma, dil/dişeti morarması', 'Oksijenlenme bozulmuştur, hızla ilerler'],
          ['İdrar yapamama (özellikle erkek kedilerde)', 'İdrar yolu tıkanıklığı 24 saat içinde böbrek yetmezliğine yol açabilir'],
          ['Tekrarlayan kusma, kanlı ishal', 'Sıvı kaybı ve enfeksiyon riski yüksektir'],
          ['Havale, bilinç kaybı, dengesiz yürüme', 'Nörolojik acil; nedeni hızla belirlenmelidir'],
          ['Zehirlenme şüphesi', 'Bazı etkenlerde antidot süresi çok kısadır'],
          ['Araç çarpması, yüksekten düşme', 'Dışarıdan görünmeyen iç kanama olabilir'],
          ['Doğum güçlüğü (30+ dakika ıkınma, yavru gelmiyor)', 'Hem anne hem yavrular risk altındadır'],
          ['Karnın şişmesi ve huzursuzluk (büyük ırk köpekler)', 'Mide dönmesi (GDV) saatler içinde ölümcüldür'],
          ['Gözde ani şişlik, dışa çıkma veya travma', 'Görme kaybı riski, ilk saatler kritiktir']
        ]
      }
    },
    {
      heading: 'Kliniğe ulaşana kadar ne yapmalısınız?',
      bullets: [
        'Önce arayın. Durumu öğrenip siz gelene kadar ekip ve ekipman hazırlanır.',
        'Hayvanınızı sıcak tutun; şoktaki hastalarda vücut ısısı hızla düşer.',
        'Taşırken omurgayı destekleyin; travma vakalarında sert bir zemin (tepsi, karton) kullanın.',
        'Zehirlenmede ambalajı veya maddenin fotoğrafını yanınızda getirin.',
        'Kusmuk, dışkı veya idrar örneği varsa getirin — tanıyı hızlandırır.',
        'Varsa aşı karnesini ve kullandığı ilaçların listesini yanınıza alın.'
      ]
    },
    {
      heading: 'Kesinlikle yapmamanız gerekenler',
      bullets: [
        'İnsan ağrı kesici vermeyin. Parasetamol kedilerde ölümcüldür; ibuprofen her iki türde de zehirlidir.',
        'Hekim önermeden kusturmaya çalışmayın — bazı maddelerde kusturmak yemek borusunu daha çok yakar.',
        'Ağzı zorla açıp su veya süt içirmeye çalışmayın; akciğere kaçabilir.',
        'Kırık şüphesinde uzvu düzeltmeye çalışmayın.',
        'Kanamada turnike uygulamayın; temiz bir bezle bastırarak gelin.',
        'İnternetten bulunan dozlarla antibiyotik başlamayın.'
      ]
    },
    {
      heading: 'Kliniğe geldiğinizde süreç nasıl işler?',
      paragraphs: [
        'Acil hastalar geliş sırasına göre değil, durumun ciddiyetine göre değerlendirilir (triyaj). ' +
        'Solunum ve dolaşımı tehlikede olan hasta önce alınır. Bu, bekleyen diğer hasta sahiplerinin ' +
        'anlayışını gerektiren ama hayat kurtaran bir uygulamadır.'
      ],
      table: {
        caption: 'Acil vakada izlenen adımlar',
        columns: ['Adım', 'İçerik'],
        rows: [
          ['Triyaj', 'Solunum, dolaşım ve bilinç düzeyi ilk dakikada değerlendirilir'],
          ['Stabilizasyon', 'Damar yolu, sıvı desteği, oksijen ve ağrı yönetimi'],
          ['Tanı', 'Gerekirse kan tahlili, röntgen ve ultrason'],
          ['Tedavi', 'Medikal tedavi veya acil cerrahi kararı'],
          ['Bilgilendirme', 'Durum, tedavi planı ve tahmini maliyet paylaşılır']
        ]
      }
    }
  ],
  faqs: [
    {
      question: 'Gece acil veteriner hizmeti veriyor musunuz?',
      answer:
        'Evet, acil vakalar için 7/24 ulaşılabiliriz. Yola çıkmadan önce telefonla haber vermeniz, ' +
        'hayvanınız için hazırlık yapmamızı ve zaman kazanmanızı sağlar.'
    },
    {
      question: 'Acil vakada randevu gerekir mi?',
      answer:
        'Hayır. Acil durumlarda randevusuz gelebilirsiniz. Yalnızca yola çıkarken arayıp haber verin.'
    },
    {
      question: 'Acil muayene ücreti ne kadar?',
      answer:
        'Acil muayene ücreti, yapılan müdahaleye ve gereken tetkiklere göre değişir. Hastanız ' +
        'stabil hale getirildikten sonra tedavi planı ve tahmini maliyet size açıkça anlatılır.'
    },
    {
      question: 'Kedim bir şey yuttu, kusturmalı mıyım?',
      answer:
        'Kendiliğinizden kusturmayın. Yutulan madde aşındırıcıysa (çamaşır suyu, lavabo açıcı) ' +
        'kusturmak yemek borusuna ikinci kez zarar verir. Önce arayın.'
    }
  ]
}

export const rontgenContent: LandingContent = {
  intro:
    'Röntgen ve ultrason, dışarıdan görünmeyen sorunları ortaya çıkaran temel tanı araçlarıdır. ' +
    'Kliniğimizde dijital röntgen (DR) kullanıyoruz; görüntü saniyeler içinde ekrana geliyor, ' +
    'bu da hem bekleme süresini hem hayvanın maruz kaldığı ışın miktarını azaltıyor.',
  sections: [
    {
      heading: 'Hangi durumlarda röntgen çekilir?',
      bullets: [
        'Topallık, kırık ve çıkık şüphesi',
        'Yabancı cisim yutulması (oyuncak, kemik, iplik)',
        'Sürekli öksürük ve nefes darlığında akciğer değerlendirmesi',
        'Kalp büyümesi şüphesi',
        'Karın şişliği, mide dönmesi (GDV) şüphesi',
        'Mesane ve böbrek taşı araştırması',
        'Doğum öncesi yavru sayısı ve konumunun belirlenmesi',
        'Yaşlı hastalarda eklem ve omurga değerlendirmesi'
      ]
    },
    {
      heading: 'Röntgen mi, ultrason mu?',
      paragraphs: [
        'İkisi birbirinin alternatifi değil, tamamlayıcısıdır. Röntgen kemik ve genel yapıyı ' +
        'gösterirken; ultrason yumuşak dokunun içini, organ yapısını ve hareketli görüntüyü verir.'
      ],
      table: {
        caption: 'Hangi yöntem neyi gösterir',
        columns: ['Yöntem', 'İyi gösterdiği', 'Tipik kullanım'],
        rows: [
          ['Dijital röntgen', 'Kemik, akciğer, genel organ sınırları', 'Kırık, yabancı cisim, akciğer, kalp gölgesi'],
          ['Ultrason', 'Yumuşak doku, organ iç yapısı, sıvı', 'Karaciğer, böbrek, gebelik, karın içi sıvı'],
          ['İkisi birlikte', 'Tam tablo', 'Karın ağrısı, açıklanamayan kilo kaybı']
        ]
      }
    },
    {
      heading: 'Röntgen zararlı mı, sedasyon gerekir mi?',
      paragraphs: [
        'Tek seferlik tanısal röntgende alınan doz çok düşüktür ve tanının sağladığı fayda bu riskin ' +
        'çok üzerindedir. Dijital sistemde doz, klasik filme göre daha da azdır.',
        'Sedasyon her zaman gerekmez. Sakin duran hastalarda doğrudan çekim yapılır. Ancak ağrılı ' +
        'bölgede pozisyon vermek gerekiyorsa veya hasta çok gergin ise, net görüntü ve hayvanın ' +
        'konforu için hafif sedasyon önerilebilir. Karar hastaya göre verilir.'
      ]
    },
    {
      heading: 'Fiyatı ne belirler?',
      paragraphs: [
        'Görüntüleme ücreti sabit değildir. Çekilecek poz sayısı, birden fazla bölge gerekip ' +
        'gerekmediği, sedasyon ihtiyacı ve ultrason eklenip eklenmediği fiyatı değiştirir. ' +
        'Muayenede ne çekileceği netleştikten sonra size işlem öncesinde tutarı söylüyoruz — ' +
        'sürpriz maliyet çıkarmıyoruz. Telefonda da tahmini aralık verebiliriz.'
      ]
    }
  ],
  faqs: [
    {
      question: 'Röntgen sonucunu ne zaman öğrenirim?',
      answer:
        'Dijital sistemde görüntü saniyeler içinde hazır olur. Değerlendirme aynı muayenede yapılır ' +
        've bulgular size ekrandan gösterilerek anlatılır.'
    },
    {
      question: 'Gebe kedimin/köpeğimin röntgeni çekilebilir mi?',
      answer:
        'Gebeliğin son döneminde yavru sayısını ve konumunu belirlemek için röntgen kullanılabilir. ' +
        'Erken gebelikte ise ultrason tercih edilir.'
    },
    {
      question: 'Başka klinikten aldığım röntgeni değerlendirir misiniz?',
      answer:
        'Evet. Elinizdeki görüntüleri getirebilir veya dijital olarak iletebilirsiniz. Gerekirse ' +
        'ek poz çekilmesi önerilebilir.'
    }
  ]
}
